module.exports = __webpack_public_path__ + "static/media/trash-grey.3542d6f3.svg";